import { BatchClassConfig } from "../models/config/BatchClassConfig";
import { ModelStoreKey } from "../models/Model";

export { ModelUrlState };

/**
 * Class to handle updating and retrieving state about Models from URL fragments
 */
class ModelUrlStateClass {
  /**
   * Return parts of URL fragment as a string [].
   * Format is [BCID, ModelName].
   * @param hash URL-Encoded URL Fragment
   */
  deconstructUrlFragment(hash: string) {
    if (hash == null || hash === "") return [];
    const decodedHash = decodeURIComponent(hash);
    const groups = decodedHash.split("\/");
    if (groups == null || (Array.isArray(groups) && groups.length === 0))
      return [];

    return [groups[1], groups[2]].filter((x) => x != null);
  }

  /**
   * Return either
   * - #/BatchClassId/ModelName
   * - #/BatchClassId
   * - #
   *
   * @param data
   * @returns
   */
  calculateUrlFragments(data: ModelStoreKey | null): string {
    let modelNameEmpty = false,
      bccIdEmpty = false;

    if (data?.name == null || data.name.trim() === "") modelNameEmpty = true;
    if (
      data?.batchClassIdentifier == null ||
      data.batchClassIdentifier.trim() === ""
    )
      bccIdEmpty = true;

    if (!bccIdEmpty && !modelNameEmpty) {
      // set bcc id and modelName
      return `#/${data!.batchClassIdentifier}/${data!.name}`;
    } else if (!bccIdEmpty) {
      // set just bcc id
      return `#/${data!.batchClassIdentifier}`;
    } else {
      return "#";
    }
  }

  updateUrlFragments(data: ModelStoreKey | null | undefined): void {
    window.location.hash = this.calculateUrlFragments(data ?? null);
  }

  updateBcc(batchClassConfig: string | BatchClassConfig | undefined) {
    const bccId =
      batchClassConfig instanceof String
        ? (batchClassConfig as string)
        : ((batchClassConfig as BatchClassConfig | undefined)?.batchClassId ??
          "");

    this.updateUrlFragments({
      batchClassIdentifier: bccId,
      name: "",
    });
  }

  filterBccs(
    batchClassConfigs: BatchClassConfig[],
  ): BatchClassConfig | undefined {
    const groups = this.deconstructUrlFragment(window.location.hash);
    if (groups.length === 0) return undefined;
    const bccId = groups[0];
    return batchClassConfigs.find((bcc) => bcc.batchClassId === bccId);
  }

  subscribeToHashChanges(callback: () => void) {
    window.addEventListener("hashchange", callback);
    return () => {
      window.removeEventListener("hashchange", callback);
    };
  }

  setupOnCloseHandler() {
    window.addEventListener("beforeunload", (e) => {
      // need to check current Documents to determine if unsaved changes exist
      // var confirmationMessage = 'There Are Unsaved Changes To Some Templates.\n'
      //     + 'These Changes Will Be Lost Unless Saved.';
      // (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      // return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    });
  }
}

const ModelUrlState = new ModelUrlStateClass();
